import { useCount } from "@/utils/count";

const load = async () => {
    await useCount().countBill();
    await useCount().countOrderConfirm();
    await useCount().countPendingWorkflow();
};

export default [
    {
        path: "/fms",
        name: "fms__root__",
        redirect: {
            name: "fms-index",
        },
        component: () => import("@/layouts/default.vue"),
        beforeEnter: async (to, from, next) => {
            await load();
            next();
        },
        meta: {
            parent: "fms",
            title: "",
        },
        children: [
            {
                path: "index",
                name: "fms-index",
                component: () => import("@/views/fms/index.vue"),
                meta: {
                    title: "控制面板",
                    icon: "index",
                    affix: true,
                },
            },
        ],
    },
    {
        path: "/fms/mall",
        name: "fms-mall",
        meta: {
            title: "研发部",
            icon: "product",
            parent: "fms",
            permission: "fms_manage_mall",
        },
        // hidden: true,
        component: () => import("@/layouts/default.vue"),
        redirect: "/fms/mall/goods",
        children: [
            {
                path: "goods",
                name: "fms-mall-goods",
                component: () => import("@/views/fms/mall/goods.vue"),
                meta: {
                    title: "全部产品",
                    icon: "goods",
                    affix: false,
                },
            },
            {
                path: "stock-record",
                name: "fms-mall-stock-record",
                component: () => import("@/views/fms/mall/stock_record.vue"),
                meta: {
                    title: "库存记录",
                    icon: "stock-record",
                    affix: false,
                },
            },
            {
                path: "category",
                name: "fms-mall-category",
                component: () => import("@/views/fms/mall/goods_category.vue"),
                meta: {
                    title: "类型配置",
                    icon: "category",
                    affix: false,
                },
            },
            {
                path: "handmade_goods",
                name: "fms-mall-handmade-goods",
                component: () => import("@/views/fms/mall/handmade_goods.vue"),
                meta: {
                    title: "在线服务",
                    icon: "platform",
                    affix: false,
                },
            },
            {
                path: "good/:id(\\d+)?",
                name: "fms-mall-goods-form",
                hidden: true,
                component: () => import("@/views/fms/mall/goods_form.vue"),
                meta: {
                    title: "产品编辑",
                    icon: "ai",
                    affix: false,
                    activeMenu: "/fms/mall/goods",
                },
            },
            {
                path: "good_detail/:id(\\d+)?",
                name: "fms-mall-goods-detail",
                hidden: true,
                component: () => import("@/views/fms/mall/goods_detail.vue"),
                meta: {
                    title: "产品详情",
                    icon: "ai",
                    affix: false,
                    activeMenu: "/fms/mall/goods",
                },
            },
        ],
    },
    {
        path: "/fms/order",
        name: "fms-order",
        meta: {
            title: "市场部",
            icon: "order",
            parent: "fms",
            permission: "fms_manage_order",
        },
        // hidden: true,
        component: () => import("@/layouts/default.vue"),
        redirect: "/fms/order/business",
        children: [
            {
                path: "business",
                name: "fms-order-business",
                component: () => import("@/views/fms/order/business.vue"),
                meta: {
                    title: "服务订单",
                    icon: "enterprise",
                    affix: false,
                },
            },
        ],
    },
    {
        path: "/fms/bill",
        name: "fms-bill",
        meta: {
            title: "财务部",
            icon: "bill",
            parent: "fms",
            permission: "fms_manage_bill",
        },
        beforeEnter: async (to, from, next) => {
            await load();
            next();
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/fms/bill/statement",
        children: [
            {
                path: "statement",
                name: "fms-bill-statement",
                component: () => import("@/views/fms/bill/statement.vue"),
                meta: {
                    title: "服务账单",
                    icon: "enterprise",
                    affix: false,
                },
            },
        ],
    },
    {
        path: "/fms/after-sales",
        name: "fms-after-sales",
        meta: {
            title: "售后部",
            icon: "after-sales",
            parent: "fms",
            permission: "fms_manage_after_sales",
        },
        beforeEnter: async (to, from, next) => {
            await load();
            next();
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/fms/after-sales/workflows",
        children: [
            // {
            //     path: "workflows-pending",
            //     name: "fms-workflows-pending",
            //     component: () => import("@/views/fms/after-sales/workflows-pending.vue"),
            //     meta: {
            //         title: "待处理工单",
            //         icon: "pending-workflow",
            //         affix: false,
            //     },
            // },
            {
                path: "workflows",
                name: "fms-workflows",
                component: () => import("@/views/fms/after-sales/workflows.vue"),
                meta: {
                    title: "全部工单",
                    icon: "workflows",
                    affix: false,
                },
            },
            {
                path: "workflows-mine",
                name: "fms-workflows-mine",
                component: () => import("@/views/fms/after-sales/workflows-pending.vue"),
                meta: {
                    title: "我的工单",
                    icon: "my-workflows",
                    affix: false,
                },
            },
            {
                path: "types",
                name: "fms-after-sales-types",
                component: () => import("@/views/fms/after-sales/types.vue"),
                meta: {
                    title: "工单类型",
                    icon: "types",
                    affix: false,
                    permission: "fms_manage_after_sales",
                },
            },
            {
                path: "create",
                name: "create-workflow",
                component: () => import("@/views/fms/after-sales/components/workflow-form.vue"),
                meta: {
                    title: "创建工单",
                    activeMenu: "/fms/after-sales/workflows",
                },
                hidden: true,
            },
            {
                path: "edit/:id(\\d+)",
                name: "edit-workflow",
                component: () => import("@/views/fms/after-sales/components/workflow-form.vue"),
                meta: {
                    title: "编辑工单",
                    activeMenu: "/fms/after-sales/workflows",
                },
                hidden: true,
            },
            {
                path: "detail/:id(\\d+)",
                name: "workflow-detail",
                component: () => import("@/views/fms/after-sales/components/workflow-detail.vue"),
                meta: {
                    title: "工单详情",
                    activeMenu: "/fms/after-sales/workflows",
                },
                hidden: true,
            },
            {
                path: "analysis",
                name: "fms-after-sales-analysis",
                component: () => import("@/views/fms/after-sales/workflows-stat.vue"),
                meta: {
                    title: "统计分析",
                    icon: "workflows-stat",
                    affix: false,
                },
            },
            {
                path: "template",
                name: "fms-after-sales-template",
                component: () => import("@/views/fms/after-sales/workflows-template.vue"),
                meta: {
                    title: "处理模板",
                    icon: "template",
                    affix: false,
                },
            },
        ],
    },
];
